module.exports = __webpack_public_path__ + "static/media/dpy.47a6ff7a.png";